// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CsFK","toggleWrap":"styles_toggleWrap__3dbEk","content":"styles_content__2H7Wh","selectAreaCode":"styles_selectAreaCode__2ccpp"};